import { CATALOGS_APP_URL, CATALOG_COLLECTIONS_APP_URL } from 'modules/catalog/catalogConstants';
import { displayDate, DATE_FORMAT_FULL_WITH_TIME } from 'utils/date';

const maxWidth = 200;

/**
 * createColumn
 * creates a column object for the collections table.
 * @param { String } name: The name (Header Cell Title) of the column.
 * @param { String } value: The value of the column.
 * @param { Object } otherProps: Additional column settings.
 * @param { Boolean } sortable: If the column is sortable.
 * @param { Boolean } disableToggle: If the column is disabled from toggling.
 * @param { Number } minWidth: The minimum width of the column.
 * @returns { Object } The column definition.
 */
export const createColumn = (
  name,
  value,
  otherProps,
  sortable = true,
  disableToggle = false,
  minWidth = 100,
) => ({
  name,
  minWidth,
  sortable,
  value,
  disableToggle,
  ...otherProps,
});

/**
 * formatDate
 * Formats a given date string to a readable date.
 * @param { String } dateString: The date string passed back from the api.
 * @returns { String } The formatted date.
 */
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return displayDate(date, DATE_FORMAT_FULL_WITH_TIME);
};

/**
 * formatCatalogUrl
 * Formats the catalog column url.
 * @param { String } url: The column url. (Not Used).
 * @param { Object } rowProps: Object containing row values.
 * @returns { String } The formatted url.
 */
export const formatCatalogUrl = (url, { catalogName }) =>
  `${CATALOGS_APP_URL}/table/${catalogName}`;

/**
 * formatNameUrl
 * Formats the name column url.
 * @param { String } url: The column url. (Not Used).
 * @param { Object } rowProps: Object containing row values.
 * @returns { String } The formatted url.
 */
export const formatNameUrl = (url, { id }) => `${CATALOG_COLLECTIONS_APP_URL}/${id}`;

/**
 * formatResultsOrder
 * Formats the results order column.
 * @param { String } value: The orderBy field. (Not Used).
 * @param { Object } rowProps: Object containing row values.
 * @returns { String } The results order string.
 */
export const formatResultsOrder = (value, { usesSmartRecos, orderBy }) => {
  if (usesSmartRecos) {
    return 'Recommendation';
  } else if (orderBy) {
    return 'By field';
  }
  return '';
};

export const NAME = createColumn(
  'Name',
  'name',
  { formatUrl: formatNameUrl, primaryAction: true, url: true },
  true,
  true,
  250,
);
export const CATALOG = createColumn(
  'Catalog',
  'catalogName',
  {
    formatUrl: formatCatalogUrl,
    link: true,
    url: true,
  },
  false,
);
export const DESCRIPTION = createColumn('Description', 'description', {}, false);
export const CREATED = createColumn('Created on', 'createdAt', { formatter: formatDate, maxWidth });
export const UPDATED = createColumn('Updated on', 'updatedAt', { formatter: formatDate, maxWidth });
export const HANDLEBARS = createColumn('Handlebars', 'handlebars', {}, false, true);
export const RESULTS_ORDER = createColumn(
  'Results order',
  'orderBy',
  {
    formatter: formatResultsOrder,
  },
  false,
);
